import React, { useCallback } from "react";

import { Input } from "@treelab/panda";

import { IFilterValue, FilterCondition, AttachmentFileTypeOptions } from "../../../../../../types/form-type";

import { FILE_TYPE_FILTERS } from "../../../../../../utils/filter_secondary";

interface IProps {
  name: string;
  value: IFilterValue;
  onChange: (value: { [key: string]: any }) => void;
}

const AttachmentSelector: React.FC<IProps> = ({ name, value, onChange }) => {
  const { filterCondition, filterString, attachmentFileTypeOptions } = value;
  const showFileTypeDropdown = filterCondition === FilterCondition.FILE_TYPE;

  const handleFileTypeChange = useCallback(
    (value: AttachmentFileTypeOptions) => {
      onChange({ attachmentFileTypeOptions: value });
    },
    [onChange]
  );

  const handleFilterStringChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ filterString: event.target.value });
    },
    [onChange]
  );

  if (showFileTypeDropdown) {
    return (
      <Input.Select
        input={{
          name: `${name}.attachmentFileTypeOptions`,
          value: attachmentFileTypeOptions,
          onChange: handleFileTypeChange,
        }}
        meta={{}}
        options={FILE_TYPE_FILTERS}
      />
    );
  }

  return (
    <Input.Text
      input={{
        name: `${name}.filterString`,
        value: filterString,
        onChange: handleFilterStringChange,
      }}
      meta={{}}
    />
  );
};

export default AttachmentSelector;
